<template>
  <div>
    <div class="default-position-button">
      <div
        class="aisea-m-0 cursor-pointer position-icon"
        @click="backToDefault()"
      />
    </div>
  </div>
</template>

<script>
/**
 * デフォルトポジションに戻るボタン
 * @parent O.MapViewGridItem
 * @props backToDefault: Function デフォルトポジションに戻り、FireStoreのtracking_targetを解除する
 */
export default {
  name: "A.DefaultPositionButton",
  props: {
    backToDefault: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.default-position-button {
  position: absolute;
  bottom: 138px;
  left: 10px;
  z-index: 5;

  .position-icon {
    background: url("../../assets/images/icons/lolcal/position_default.svg")
      no-repeat;
    background-size: contain;
    width: 29px;
    height: 36px;

    &:hover {
      background: url("../../assets/images/icons/lolcal/position_hover.svg")
        no-repeat;
      background-size: contain;
    }

    &:active {
      background: url("../../assets/images/icons/lolcal/position_click.svg")
        no-repeat;
      background-size: contain;
    }
  }
}
</style>
